import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=c3b8440c"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=c3b8440c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports